import moment from 'moment-timezone';
import { BookDate } from './clearSingleDatesAndDateRanges';

/**
 * @description
 * Sort given dates and self contained date-ranges
 *
 * @param dates collection of dates and date-ranges
 * @returns sorted collection
 */
export const sortDateAndRangeArray = (dates: BookDate[]): BookDate[] =>
  dates.sort((date1: BookDate, date2: BookDate) => {
    const date1in = moment(date1[0]);
    const date2in = moment(date2[0]);
    if (date1[1] === null) {
      // date1 is SingleDate
      if (date2[1] === null) {
        // both are SingleDate
        return date1in.isAfter(date2[0]) ? 1 : -1;
      }
      // date1: SingleDate, date2: Range
      return date1in.isAfter(date2[1]) ? 1 : -1;
    }
    if (date2[1] === null) {
      // date1: Range, date2: SingleDate
      return date2in.isAfter(date1[1]) ? -1 : 1;
    }
    // below, both are range
    const date1out = moment(date1[1]);
    if (date1in.isBefore(date2in) && date1out.isBefore(date2in)) {
      // date1 is before of date2
      return -1;
    }
    if (date1in.isBefore(date2in) && !date1out.isBefore(date2in)) {
      // date1 overlaps left of date2
      return -1;
    }
    // date1 is after date2
    return 1;
  });
